import { UserAgentApplication } from 'msal';

interface Config {
    appId: string;
    prodUri: string;
    qaUri: string;
    devUri: string;
    redirectUri: string;
}

export const getUri = (config: Config): string => {
    console.log(config);
    switch (process.env.NODE_ENV) {
        case 'production':
            return config.prodUri;
        case 'test':
            return config.qaUri;
        case 'development':
            return config.devUri;
        default:
            return config.redirectUri;
    }
};

export const userAgentApplication = (config: Config): UserAgentApplication =>
    new UserAgentApplication({
        auth: {
            clientId: config.appId,
            redirectUri: getUri(config),
            postLogoutRedirectUri: getUri(config),
        },
        cache: {
            cacheLocation: 'sessionStorage',
            storeAuthStateInCookie: true,
        },
    });
